import React from 'react';
import './style.css';

const PKButton = props => {
    return <button className={props.theme} onClick={props.OnClickMet} type={props.type !== undefined || null ? props.type : null} 
    style={props.style !== undefined ? props.style : null}> {props.children} </button>
};

export default PKButton;